import React, {FC} from 'react'
import {UseFormRegister, FieldErrors} from 'react-hook-form'
type InputProps = {
  name: string
  register: UseFormRegister<any>
  errors: FieldErrors
  onChange?: (e: any) => void
  defaultValue?: string
  minValue?: string
  disabled?: boolean
  maxValue?: string
}

const InputDate: FC<InputProps> = ({
  name,
  register,
  errors,
  onChange,
  defaultValue = '',
  minValue = '1999-01-01',
  maxValue = '3999-01-01',
  disabled = false,
  ...props
}) => {
  return (
    <div className='sdx_form_input'>
      <input
        type='Date'
        className='form-control sdx-centra-input-form'
        {...register(name)}
        defaultValue={defaultValue}
        min={minValue ? minValue : '1999-01-01'}
        max={maxValue ? maxValue : '3999-01-01'}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputDate
